import { getBusinessTodayDate } from './dateUtils';

export const HOTBOX_DEFAULT_DATE_RANGE_DAYS = 30;

/**
 * Default date range for the Hotbox filter.
 *
 * Matches WellSky behavior: inclusive [today - 30 days, today] using the
 * Pacific business calendar so the UI agrees with backend validation.
 */
export function getDefaultHotboxDateRange(): { from: Date; to: Date } {
  const today = getBusinessTodayDate();
  const from = new Date(today);
  from.setDate(from.getDate() - HOTBOX_DEFAULT_DATE_RANGE_DAYS);
  return { from, to: today };
}
